var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"/"}},[_c('img',{staticClass:"my-12 w-40 mx-auto",attrs:{"alt":"MOZYS logo","src":require("@/assets/logo.svg")}})])}]

export { render, staticRenderFns }